<script lang="ts">
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import type { BottomSectionStoryblok } from '$types/bloks';
  import CollectionsCrossSell from './marketing-sub-blocks/collections-cross-sell.svelte';
  import ProductRecommendations from './marketing-sub-blocks/product-recommendations.svelte';
  import ShopTheLookCards from './marketing-sub-blocks/shop-the-look-cards.svelte';

  export let block: BottomSectionStoryblok;
  export let referenceProductId: string | undefined = undefined;
</script>

<section use:storyblokEditable={block} class="px-2 lg:px-8 !py-0">
  <div class="container mx-auto lg:pt-0 pt-[88px] mb-2 lg:mb-0 relative">
    <h2 class="px-2 lg:px-0 text-4xl font-semibold top-[88px] lg:absolute left-0 right-0">
      {block.title}
    </h2>
  </div>

  <div class="lg:pt-[88px]">
    {#each block.content as content}
      {#if content.component === 'shop-the-look-cards'}
        <ShopTheLookCards {content} />
      {:else if content.component === 'collections-cross-sell'}
        <CollectionsCrossSell {content} />
      {:else if content.component === 'product-recommendations'}
        <ProductRecommendations {content} {referenceProductId} />
      {/if}
    {/each}
  </div>
</section>
